import '@babel/polyfill'
import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import Multiselect from 'vue-multiselect'
import VueTheMask from "vue-the-mask";
import JsonExcel from 'vue-json-excel'
import VueBasicAutocomplete from 'vue-basic-autocomplete'
import VueModality from 'vue-modality'

import './plugins/bootstrap-vue'
import 'font-awesome/css/font-awesome.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import './assets/css/globais.css'

Vue.component('multiselect', Multiselect)
Vue.component('downloadExcel', JsonExcel)

Vue.use(VueTheMask)
Vue.use(VueBasicAutocomplete)
Vue.use(VueModality)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
